// Copyright (c) 2016 Deere & Company

export const getSpecialAllowanceTotalContribution = calculations => {

    const company = calculations.companyContribution ? calculations.companyContribution : 0;
    const customer = calculations.customerContribution ? calculations.customerContribution : 0;
    const dealer = calculations.dealerContribution ? calculations.dealerContribution : 0;

    return company + customer + dealer;

};



// WEBPACK FOOTER //
// ./src/claim/spa/services/spa-calculations.js